import { defineStore } from 'pinia'
import L from 'leaflet'

export const useMapState = defineStore('mapState', {
  state: () => ({
    leaflet: L,
    map: null,
    drawControl: null,
    drawnItems: null,
    currentTileLayer: null,
    tileLayers: {},
    myLocationMarker: null,
    myLocationCircle: null,
    flightLayer: null,
    routeLine: null,
    mapContainer: null, // Store the container ID
    appInstance: null, // Store the app instance
    isMapReady: false,
    enableWaypointMode: null,
    disableWaypointMode: null,
    deleteLastWaypoint: null, // Add this
    // ✅ NEW: Add waypoints management variables
    waypoints: [],
    waypointMarkers: [],
    distanceMarkers: [],
    waypointsRouteLine: null // Renamed to avoid conflict with existing routeLine
  })
})
